import React, { useState } from 'react'
import { IFilter, IGenericObject, TableWithFields } from '@types'
import { Button, Card, Input } from '@ss/meta-core-components'
import styled from '@emotion/styled'

interface Props {
  setParams: React.Dispatch<React.SetStateAction<TableWithFields>>
  children: React.ReactNode
  nameFilter?: boolean
}

/**
 * Componente filtri per le pagine NLP e StartUp
 * @param props.setParams {Function}
 * @param props.children {React.ReactNode}
 * @param props.nameFilter{boolean=}
 * @component
 */
export const StartUpFilters: React.FC<Props> = (props) => {
  const { setParams, children, nameFilter = true } = props

  const [filterValue, setFilterValue] = useState<
    IGenericObject<IFilter | null>
  >({})

  return (
    <Container>
      <Card
        width={'100%'}
        height={'70px'}
        position={'start center'}
        dataCy={'filters'}
      >
        <FilterContainer>
          <InputContainer>
            <InputLabel>Codice fiscale</InputLabel>
            <Input
              placeholder={'Inserisci'}
              dataCy={'code-input'}
              value={filterValue.codice_fiscale?.value || undefined}
              onChange={(data) =>
                setFilterValue({
                  ...filterValue,
                  codice_fiscale: data
                    ? {
                        value: `${data}`,
                        method: 'normal',
                      }
                    : null,
                })
              }
            />
          </InputContainer>
          {nameFilter ? (
            <InputContainer>
              <InputLabel>Nome Azienda</InputLabel>
              <Input
                placeholder={'Inserisci'}
                dataCy={'name-input'}
                value={filterValue.denominazione?.value || undefined}
                onChange={(data) =>
                  setFilterValue({
                    ...filterValue,
                    denominazione: data
                      ? { value: `${data}`, method: 'fuzzy' }
                      : null,
                  })
                }
              />
            </InputContainer>
          ) : (
            <InputContainer></InputContainer>
          )}
          <Button
            dataCy={'find-start-up'}
            onClick={() =>
              setParams((old) => ({ ...old, filters: filterValue }))
            }
          >
            Cerca Startup
          </Button>
        </FilterContainer>
      </Card>
      {children}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 46px 30px 30px 30px;
`
const FilterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 300px;
  gap: 20px;
`
const InputContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 10px;
`
const InputLabel = styled.div`
  place-self: center;
`
